import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { StyledInput, InputWrapper, StyledLabel } from './styles';

const RadioButton = forwardRef(
  (
    {
      error,
      label,
      name,
      id,
      defaultChecked,
      disabled,
      boldWhenChecked,
      ...rest
    },
    ref
  ) => (
    <InputWrapper>
      <StyledInput
        type="radio"
        name={name}
        id={id || name}
        $error={error}
        defaultChecked={defaultChecked}
        disabled={disabled}
        ref={ref}
        data-input-scroll-id={name}
        {...rest}
      />
      <StyledLabel
        htmlFor={id || name}
        $defaultChecked={boldWhenChecked && defaultChecked}
        $disabled={disabled}
      >
        {label}
      </StyledLabel>
    </InputWrapper>
  )
);

RadioButton.displayName = 'RadioButton';

RadioButton.propTypes = {
  error: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  boldWhenChecked: PropTypes.bool,
};

export default RadioButton;
